"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var WebClientFetchRequester_1 = require("../requester/WebClientFetchRequester");
var webClientRequester_1 = require("../requester/webClientRequester");
var GetSessionInfoMethod_1 = require("../api/methods/GetSessionInfoMethod");
var vizPortalWebClientHelpers_1 = require("../api/vizPortalWebClientHelpers");
var SessionState;
(function (SessionState) {
    SessionState[SessionState["Exists"] = 0] = "Exists";
    SessionState[SessionState["NoSession"] = 1] = "NoSession";
    SessionState[SessionState["Unknown"] = 2] = "Unknown";
})(SessionState || (SessionState = {}));
/*
Purpose of this object is to manage the current session state and provide helpers.
Can do the following:
- Fetch the session from the server
- Cache the current session
- TODO: Add a listener for changes to the session
*/
var SessionManager = (function (_super) {
    __extends(SessionManager, _super);
    function SessionManager(requester) {
        if (requester === void 0) { requester = new WebClientFetchRequester_1.WebClientFetchRequester(); }
        var _this = _super.call(this) || this;
        _this.sessionState = SessionState.Unknown;
        _this.numSessionInfoRequests = 0;
        _this.sessionInfoPromise = Promise.resolve();
        _this.fetchSession = webClientRequester_1.WebClientRequesterWrapper.createSender(requester, GetSessionInfoMethod_1.GetSessionInfoMethod);
        return _this;
    }
    SessionManager.prototype.getSession = function () {
        return this.sessionInfo;
    };
    SessionManager.prototype.getSessionInfoPromise = function () {
        return this.sessionInfoPromise;
    };
    SessionManager.prototype.waitForSession = function () {
        return (this.numSessionInfoRequests > 0) ? this.sessionInfoPromise : Promise.resolve();
    };
    /**
     * Adds the request to a queue of other session update requests
     * @param makeRequest, if the promise from makeRequest successfully returns void then the session will be cleared
     * @returns {PromiseLike<void>} The promise will return void but the session can be retrieved by SessionManager::getSession()
     */
    SessionManager.prototype.sessionInfoRequest = function (makeRequest) {
        var _this = this;
        var decrementSessionInfoRequests = function () { _this.numSessionInfoRequests--; };
        this.numSessionInfoRequests++;
        this.sessionInfoPromise = this.waitForSession()
            .then(makeRequest)
            .then(this.setSessionInfo.bind(this))
            .then(// Acts like finally
        decrementSessionInfoRequests, decrementSessionInfoRequests // Make the promise successful to keep the chain going
        )
            .then(function () { return _this.getSession(); });
        return this.sessionInfoPromise;
    };
    SessionManager.prototype.ensureSessionInfo = function () {
        if (!this.sessionInfo && !this.numSessionInfoRequests) {
            return this.refreshSessionInfo();
        }
        return this.waitForSession();
    };
    SessionManager.prototype.refreshSessionInfo = function () {
        var _this = this;
        return this.sessionInfoRequest(function () {
            var fetchSuccessfulSession = function () { return _this.fetchSession().then(vizPortalWebClientHelpers_1.getSuccessResult); };
            var fetchSessionPromise = fetchSuccessfulSession();
            if (!WebClientFetchRequester_1.WebClientFetchRequester.getXsrfToken()) {
                // Getting the session the first time will fail because the XSRF token is not set.
                // Use the first request to set the XSRF token cookie and the second to actually get the session.
                // This only works on desktop where the auth header is added to all requests but will not work in the browser
                // because the WebClient API clears the workgroup_session_id header when a request fails authentication.
                fetchSessionPromise = fetchSessionPromise.then(function (s) { return s; }, fetchSuccessfulSession);
            }
            return fetchSessionPromise.then(function (s) { return s; }, function () { return undefined; }); // Make a successful promise and clear the session
        });
    };
    SessionManager.prototype.setSessionInfo = function (newSessionInfo) {
        if (!newSessionInfo) {
            this.clearSessionInfo();
            return;
        }
        this.sessionInfo = newSessionInfo;
        this.sessionState = SessionState.Exists;
        this.emit(SessionManager.SESSION_UPDATED_EVENT);
    };
    SessionManager.prototype.clearSessionInfo = function () {
        if (this.sessionState === SessionState.NoSession) {
            return;
        }
        this.sessionState = SessionState.NoSession;
        delete this.sessionInfo;
        this.emit(SessionManager.SESSION_UPDATED_EVENT);
    };
    SessionManager.SESSION_UPDATED_EVENT = 'sessionUpdated';
    return SessionManager;
}(events_1.EventEmitter));
exports.SessionManager = SessionManager;
//# sourceMappingURL=SessionManager.js.map